import { ReactNode } from "react";
import { DateTimeModel, ShipmentType } from "./shipmentCard.types";
import { Nullable, ValueOf } from "shared/lib/typeCheck.lib";
import { t } from "shared/localization/localization";

export type ProgressLineProps = {
  percent: number;
  status: "location-data" | "not-founded";
  rotation: "horizontal" | "vertical";
  className?: string;
};

export type RenderRoadCardProps = {
  shipmentType: ValueOf<typeof ShipmentType>;
  etd: Nullable<DateTimeModel>;
  eta: Nullable<DateTimeModel>;
  ata: Nullable<DateTimeModel>;
  atd: Nullable<DateTimeModel>;
  reference: string;
  status: ValueOf<typeof RoadStatusesModel>;
  pieces: string;
  carrierName: string;
  scac?: string | null;
  directionFrom: Nullable<string>;
  directionTo: Nullable<string>;
  progressLine: ProgressLineProps;
  onOpen: () => void;
  onDelete: () => void;
};

export type RenderRoadSearchErrorCardProps = {
  className?: string;
  reference?: Nullable<string>;
  text?: ReactNode;
  status?: ErrorStatus;
  onRetry?: () => void;
  onDelete?: () => void;
};

export const RoadStatusesDTO = {
  BOOKED: "BOOKED",
  RECEIVED: "RECEIVED",
  DELIVERED: "DELIVERED",
  IN_TRANSIT: "IN_TRANSIT",
  ARRIVED: "ARRIVED",
  NOTIFIED: "NOTIFIED",
  DEPARTED: "DEPARTED",
  CANCELLED: "CANCELLED",
  UNKNOWN: "UNKNOWN",
} as const;

export const RoadStatusesModel = {
  ...RoadStatusesDTO,
} as const;

export const RoadMessagesDTO = {
  OK: "OK",
  CARRIER_HASNT_PROVIDE_INFO: "CARRIER_HASNT_PROVIDE_INFO",
  CARRIER_NO_RESPONSE: "CARRIER_NO_RESPONSE",
  CARRIER_NOT_SUPPORTED: "CARRIER_NOT_SUPPORTED",
  CARRIER_NOT_SUPPORT_SHIPMENT_TYPE: "CARRIER_NOT_SUPPORT_SHIPMENT_TYPE",
  CARRIER_TEMPORARY_DISABLED: "CARRIER_TEMPORARY_DISABLED",
  CARRIER_UNDER_MAINTENANCE: "CARRIER_UNDER_MAINTENANCE",
  AUTO_CANT_DETECT_CARRIER: "AUTO_CANT_DETECT_CARRIER",
  WRONG_NUMBER: "WRONG_NUMBER",
  WRONG_TYPE: "WRONG_TYPE",
  WRONG_PARAMETERS: "WRONG_PARAMETERS",
  WRONG_CARRIER: "WRONG_CARRIER",
  UNEXPECTED_ERROR: "UNEXPECTED_ERROR",
  API_KEY_ACCESS_DENIED: "API_KEY_ACCESS_DENIED",
  API_KEY_EXPIRED: "API_KEY_EXPIRED",
  API_KEY_RATE_LIMIT: "API_KEY_RATE_LIMIT",
  API_KEY_WRONG: "API_KEY_WRONG",
} as const;

export const RoadMessagesModel = {
  ...RoadMessagesDTO,
} as const;

export type ErrorStatus = "not-defined" | "error" | "warn";

export const roadErrorMessageMap: Partial<Record<ValueOf<typeof RoadMessagesModel>, string>> = {
  [RoadMessagesModel.WRONG_NUMBER]: t("Incorrect tracking number"),
  [RoadMessagesModel.CARRIER_HASNT_PROVIDE_INFO]: t("Rail operator hasn't provided info yet"),
  [RoadMessagesModel.CARRIER_NOT_SUPPORTED]: t("The rail operator is not supported at the moment"),
};

export const roadStatusLabelMap: Record<ValueOf<typeof RoadStatusesModel>, string> = {
  [RoadStatusesModel.IN_TRANSIT]: t("In transit"),
  [RoadStatusesModel.DELIVERED]: t("Delivered"),
  [RoadStatusesModel.BOOKED]: t("Booked"),
  [RoadStatusesModel.RECEIVED]: t("Received"),
  [RoadStatusesModel.ARRIVED]: t("Arrived"),
  [RoadStatusesModel.NOTIFIED]: t("Notified"),
  [RoadStatusesModel.UNKNOWN]: t("Unknown"),
  [RoadStatusesModel.DEPARTED]: t("Departed"),
  [RoadStatusesModel.CANCELLED]: t("Cancelled"),
};
